module.exports = __webpack_public_path__ + "assets/img/Testbuy.d35caf04.jpg";